// 国名 ↔ ISO コード変換
// 日本語国名 ↔ ISO コードのデータは destination-master-store 経由で DB から取得します
// 英語国名 ↔ ISO コードは world.svg の path id 構造に基づく静的データです
import { useDestinationMasterStore } from "@/store/destination-master-store.js";
import {
  COUNTRY_ALIAS_TO_ISO_CODE,
  getISOCodeFromAliasRows,
} from "./countryAliases";

// ISO国コード → 英語国名 (world.svgのpath id用)
export const ISO_CODE_TO_ENGLISH_NAME = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AI: "Anguilla",
  AM: "Armenia",
  AO: "Angola",
  AR: "Argentina",
  AU: "Australia",
  AW: "Aruba",
  AT: "Austria",
  AZ: "Azerbaijan",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  VG: "British Virgin Islands",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CA: "Canada",
  KH: "Cambodia",
  CM: "Cameroon",
  CF: "Central African Republic",
  TD: "Chad",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CZ: "Czech Republic",
  CI: "Côte d'Ivoire",
  KP: "Dem. Rep. Korea",
  CD: "Democratic Republic of the Congo",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FI: "Finland",
  GF: "French Guiana",
  GA: "Gabon",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GL: "Greenland",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao PDR",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LT: "Lithuania",
  LU: "Luxembourg",
  MK: "Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MV: "Maldives",
  ML: "Mali",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine",
  PA: "Panama",
  PY: "Paraguay",
  PE: "Peru",
  PL: "Poland",
  PT: "Portugal",
  QA: "Qatar",
  CG: "Republic of Congo",
  KR: "Republic of Korea",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  LC: "Saint Lucia",
  VC: "Saint Vincent and the Grenadines",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SL: "Sierra Leone",
  SK: "Slovakia",
  SI: "Slovenia",
  SO: "Somalia",
  ZA: "South Africa",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  GM: "The Gambia",
  TL: "Timor-Leste",
  TG: "Togo",
  TN: "Tunisia",
  TM: "Turkmenistan",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VE: "Venezuela",
  VN: "Vietnam",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  IT: "Italy",
  GB: "United Kingdom",
  FR: "France",
  KN: "Saint Kitts and Nevis",
  AD: "Andorra",
  SM: "San Marino",
  MC: "Monaco",
  LI: "Liechtenstein",
  MT: "Malta",
  CY: "Cyprus",
  GR: "Greece",
  VA: "Vatican City",
  FJ: "Fiji",
  PG: "Papua New Guinea",
  SB: "Solomon Islands",
  VU: "Vanuatu",
  WS: "Samoa",
  KI: "Kiribati",
  TO: "Tonga",
  FM: "Micronesia",
  PH: "Philippines",
  ID: "Indonesia",
  MY: "Malaysia",
  SG: "Singapore",
  BS: "Bahamas",
  TT: "Trinidad and Tobago",
  PR: "Puerto Rico",
  SC: "Seychelles",
  MU: "Mauritius",
  CV: "Cape Verde",
  ST: "Sao Tome and Principe",
  KM: "Comoros",
};

// 英語国名 → ISO国コード
export const ENGLISH_NAME_TO_ISO_CODE = {};
for (const [isoCode, englishName] of Object.entries(ISO_CODE_TO_ENGLISH_NAME)) {
  ENGLISH_NAME_TO_ISO_CODE[englishName] = isoCode;
  ENGLISH_NAME_TO_ISO_CODE[englishName.toLowerCase()] = isoCode;
}

/**
 * 日本語国名 → ISO 3166-1 alpha-2コード（DBから取得したデータを使用）
 * @param {string} countryName - 日本語国名
 * @returns {string|null}
 */
// DB未登録・表記ゆれ用の別名（国名制限の緩和）
const COUNTRY_NAME_ALIASES = {
  台湾: "TW",
  台灣: "TW",
  "台湾（中華民国）": "TW",
  香港: "HK",
  大韓民国: "KR",
  韓国: "KR",
  アメリカ: "US",
  アメリカ合衆国: "US",
  イギリス: "GB",
  英国: "GB",
};

export function getISOCode(countryName) {
  if (!countryName) return null;
  const store = useDestinationMasterStore();
  const normalized = String(countryName).trim();
  const lowerNormalized = normalized.toLowerCase();
  return (
    store.countryToIsoCode[normalized] ||
    COUNTRY_NAME_ALIASES[normalized] ||
    COUNTRY_ALIAS_TO_ISO_CODE[normalized] ||
    COUNTRY_ALIAS_TO_ISO_CODE[lowerNormalized] ||
    getISOCodeFromAliasRows(normalized, store.countryAliases) ||
    ENGLISH_NAME_TO_ISO_CODE[normalized] ||
    ENGLISH_NAME_TO_ISO_CODE[lowerNormalized] ||
    null
  );
}

/**
 * 英語国名 → ISO 3166-1 alpha-2コード（world.svg のpath class属性用）
 * @param {string} englishName
 * @returns {string|null}
 */
export function getISOCodeFromEnglish(englishName) {
  if (!englishName) return null;
  return ENGLISH_NAME_TO_ISO_CODE[englishName] || null;
}

/**
 * ISO コード → 英語国名
 * @param {string} isoCode
 * @returns {string|null}
 */
export function getEnglishName(isoCode) {
  if (!isoCode) return null;
  return ISO_CODE_TO_ENGLISH_NAME[isoCode] || null;
}

/**
 * ISO コード → 日本語国名（DBから取得したデータを使用）
 * @param {string} isoCode
 * @returns {string|null}
 */
export function getJapaneseName(isoCode) {
  if (!isoCode) return null;
  const store = useDestinationMasterStore();
  return store.isoCodeToCountryName[isoCode] || null;
}
